"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = capitalize;
/**
 * Capitalizes each word in a sentence.
 * @param  {String} string Sentence to be capitalize.
 * @return {String}        The Capitalized sentence.
 */
function capitalize(string) {
  string = string.toLowerCase();
  return string.replace(/(^|[^a-zA-Z\u00C0-\u017F'])([a-zA-Z\u00C0-\u017F])/g, function (word) {
    return word.toUpperCase();
  });
}